import { render, staticRenderFns } from "./storage.vue?vue&type=template&id=a0f7d5ca&scoped=true"
import script from "./storage.vue?vue&type=script&lang=js"
export * from "./storage.vue?vue&type=script&lang=js"
import style0 from "./storage.vue?vue&type=style&index=0&id=a0f7d5ca&prod&lang=scss&scoped=true"
import style1 from "./storage.vue?vue&type=style&index=1&id=a0f7d5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f7d5ca",
  null
  
)

export default component.exports